import { memo } from "react";
import { Bank, EmptyWallet } from "@zenith/assets/icons/components";
import { TRANSFER_OPTIONS } from "../constants";

interface TransferOptionsProps {
  selectedOption: "bank" | "wallet";
  onOptionChange: (option: "bank" | "wallet") => void;
}

const TransferOptions = memo(function TransferOptions({
  selectedOption,
  onOptionChange,
}: TransferOptionsProps) {
  return (
    <div className="mb-4 block gap-4 xs:flex">
      <button
        onClick={() => onOptionChange(TRANSFER_OPTIONS.BANK)}
        className={`mb-2 w-full flex-1  rounded-lg border p-4 xs:mb-0 ${
          selectedOption === TRANSFER_OPTIONS.BANK
            ? "border-primary-300 bg-red-50"
            : "border-neutral-200"
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          <Bank className="h-6 w-6" />
          <div className="text-lg font-medium">To Bank Account</div>
          <div className="text-sm text-neutral-600">
            Send money to any bank account
          </div>
        </div>
      </button>
      <button
        onClick={() => onOptionChange(TRANSFER_OPTIONS.WALLET)}
        className={`w-full flex-1 rounded-lg border p-4 ${
          selectedOption === TRANSFER_OPTIONS.WALLET
            ? "border-primary-300 bg-red-50"
            : "border-neutral-200"
        }`}
      >
        <div className="flex flex-col items-center gap-2">
          <EmptyWallet className="h-6 w-6" />
          <div className="text-lg font-medium">To Finopay Wallet</div>
          <div className="text-sm text-neutral-600">
            Send money to another Finopay merchant
          </div>
        </div>
      </button>
    </div>
  );
});

export default TransferOptions;
